import { render, staticRenderFns } from "./Booth.vue?vue&type=template&id=1e162a94&scoped=true&"
import script from "./Booth.vue?vue&type=script&lang=ts&"
export * from "./Booth.vue?vue&type=script&lang=ts&"
import style0 from "./Booth.vue?vue&type=style&index=0&id=1e162a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e162a94",
  null
  
)

export default component.exports